import React from 'react';
import Modal from 'react-modal';

// Modal wrapper using react-modal
export const Dialog = ({ open, onOpenChange, children, ...props }) => (
  <Modal
    isOpen={open}
    onRequestClose={onOpenChange}
    overlayClassName="modal-overlay"
    className="modal-content"
    ariaHideApp={false}
    {...props}
  >
    {children}
  </Modal>
);

export const DialogContent = ({ children, ...props }) => (
  <div {...props}>{children}</div>
);

export const DialogHeader = ({ children, ...props }) => (
  <div {...props}>{children}</div>
);

export const DialogTitle = ({ children, ...props }) => (
  <h2 {...props}>{children}</h2>
);

export const DialogFooter = ({ children, ...props }) => (
  <div {...props}>{children}</div>
);